import React from 'react'
import './TopNav.css'

const TopNav = () => {
  return (
    <nav className='navbar'>
      <div className='header'>
      </div>
    </nav>
  )
}

export default TopNav
